import React, { useState, useEffect } from "react";
import styled from "styled-components";

import PrintCampaignCreateChannelDataEditor from "../../print-channel-editor/PrintCampaignCreateChannelDataEditor.jsx";
import ChannelDataSelectList from "../../../../Previews/Campaign__Create_ChannelDataSelectList.jsx";
import HTMLEditor from "../../../../Previews/Campaign__Create_HTMLEditor.jsx";
import {
  linkedInCareerLevels,
  linkedInEmploymentTypes,
  linkedInSectors,
  linkedInFunctions,
  linkedInLands
} from "../../../../Previews/constants.js";
import { channelsByShortName } from "../../../../../../data/app__channels.js";
import { useTranslation } from "react-i18next";

//------------------------------------------------------------------------------
// Styled Components
//------------------------------------------------------------------------------
const PostEditorLinkedInWrapper = styled.div`
  width: 580px;
  background-color: #fff;
  box-shadow: 0px 2px 4px 0px #1516331f;
  border-radius: 4px;
`;
const HeaderWrapper = styled.div`
  position: relative;
  padding: 15px;
  text-align: left;
`;
const HeaderPicture = styled.img`
  width: 100%;
  height: 75px;
  object-fit: cover;
  border-radius: 4px 4px 0 0;
`;
const Logo = styled.img`
  position: absolute;
  top: -20px;
  left: 20px;
  width: 70px;
  height: 70px;
`;
const HeaderIcons = styled.img`
  width: 60px;
  margin-left: auto;
  margin-bottom: 35px;
  display: block;
`;
const TitleWrapper = styled.div`
  display: flex;
  margin-left: -6px;
`;
const SaveButton = styled.div`
  background: white;
  color: rgb(0, 114, 176);
  width: 150px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  border-radius: 4px;
  border: 1px solid rgb(0, 114, 176);
  margin-right: 10px;
`;
const ApplyButton = styled.a`
  background: rgb(0, 114, 176);
  width: 150px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  border-radius: 4px;
  color: white;
`;
const CompanyWrapper = styled.div`
  display: flex;
  font-size: 15px;
  margin: 10px 0 10px -6px;
`;
const HeaderInfo = styled.div`
  display: flex;
  justify-content: space-between;
`;
const HeaderInfoText = styled.div`
  color: rgba(0, 0, 0, 0.4);
  font-size: 14px;
`;
const Underline = styled.div`
  width: 50%;
  height: 1px;
  background-color: rgba(191, 191, 191, 0.3);
  margin-top: 10px;
`;
const BodyWrapper = styled.div`
  width: 100%;
`;
const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
`;
const SelectListsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
const HTMLEditorWrapper = styled.div`
  max-width: 618px;
  margin-left: -10px;
`;
const Requirements = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  padding: 0 15px 15px;
`;
const RequirementsDetails = styled.div`
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 15px;
`;
const SelectListWrapper = styled.div`
  margin-bottom: 20px;
  width: 48%;
`;
const titleStyle = {
  fontWeight: 500,
  fontSize: "22px",
  fontFamily: "Inter, sans-serif",
  lineHeight: "1.2em"
};
const companyNameStyle = {
  fontWeight: 500,
  fontSize: "14px",
  fontFamily: "Inter, sans-serif"
};
const pageNameStyle = {
  fontWeight: 300,
  fontSize: "14px",
  fontFamily: "Inter, sans-serif"
};
//------------------------------------------------------------------------------
// Main Functional Component
//------------------------------------------------------------------------------
const PrintPostEditorLinkedIn = ({
  postData,
  channelData,
  updatePost,
  editable,
  orgaLinkedInPageID
}) => {
  const [linkedInCompanyId, setLinkedInCompanyId] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    if (channelData.linkedInCompanyId) {
      setLinkedInCompanyId(channelData.linkedInCompanyId);
    } else if (orgaLinkedInPageID) {
      setLinkedInCompanyId(orgaLinkedInPageID);
    } else {
      setLinkedInCompanyId("");
    }
  }, [orgaLinkedInPageID, channelData]);

  return (
    <PostEditorLinkedInWrapper>
      <HeaderPicture src="/images/linkedin-bg.jpeg" alt="" />
      <HeaderWrapper>
        <Logo src="/images/azubi.png" alt="" />
        <HeaderIcons src="/images/linkedin_tools.png" alt="" />
        <TitleWrapper>
          <PrintCampaignCreateChannelDataEditor
            value={channelData.title}
            dataKey="title"
            textStyle={titleStyle}
            limit={channelsByShortName.linkedin.limits.title}
            label={t("Job Title")}
            tooltip={t("Job Title")}
            editable={editable}
          />
        </TitleWrapper>
        <CompanyWrapper>
          <PrintCampaignCreateChannelDataEditor
            value={channelData.companyName}
            dataKey="companyName"
            textStyle={companyNameStyle}
            limit={channelsByShortName.linkedin.limits.companyName}
            label="FIRMENNAME"
            tooltip="FIRMENNAME"
            editable={editable}
          />
          ·
          <PrintCampaignCreateChannelDataEditor
            value={channelData.pageName}
            dataKey="pageName"
            textStyle={pageNameStyle}
            limit={channelsByShortName.linkedin.limits.pageName}
            label="STANDORT"
            tooltip="STANDORT"
            editable={editable}
          />
          ·
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 0 }}>
            <PrintCampaignCreateChannelDataEditor
              value={linkedInCompanyId}
              dataKey="linkedInCompanyId"
              textStyle={pageNameStyle}
              limit={channelsByShortName.linkedin.limits.companyId}
              label="KUNDEN ID"
              tooltip="Kunden ID"
              editable={editable}
            />
            {linkedInCompanyId ? (
              <a
                href={`https://www.linkedin.com/jobs/search/?${new URLSearchParams({
                  f_C: linkedInCompanyId
                })}`}
                rel="noreferrer noopener"
                target="_blank"
              >
                🌍
              </a>
            ) : null}
          </div>
        </CompanyWrapper>
        <HeaderInfo>
          <HeaderInfoText>
            <div>
              <b style={{ color: "black" }}>NEU</b> Gepostet vor: 2 Minuten
            </div>
          </HeaderInfoText>
          <div style={{ display: "flex" }}>
            <SaveButton>Speichern</SaveButton>
            <ApplyButton target="_blank" href={channelData?.url || "#"}>
              Einfach bewerben
            </ApplyButton>
          </div>
        </HeaderInfo>
        <Underline />
      </HeaderWrapper>
      <BodyWrapper>
        <BodyContent>
          {editable && (
            <Requirements>
              <SelectListsWrapper>
                {!editable && ( // this is not used anymore
                  <SelectListWrapper>
                    <ChannelDataSelectList
                      label="LAND"
                      options={linkedInLands}
                      value={channelData.land}
                      dataKey="land"
                    />
                  </SelectListWrapper>
                )}
                <SelectListWrapper>
                  <ChannelDataSelectList
                    label="KARRIERESTUFE"
                    options={linkedInCareerLevels}
                    value={channelData.careerLevel}
                    dataKey="careerLevel"
                    editable={editable}
                  />
                </SelectListWrapper>
                <SelectListWrapper>
                  <ChannelDataSelectList
                    label="BESCHÄFTIGUNGSVERHÄLTNIS"
                    options={linkedInEmploymentTypes}
                    value={channelData.employmentType}
                    dataKey="employmentType"
                    editable={editable}
                  />
                </SelectListWrapper>
              </SelectListsWrapper>
              <SelectListsWrapper>
                <SelectListWrapper>
                  <ChannelDataSelectList
                    label="BRANCHE / INDUSTRIE"
                    options={linkedInSectors}
                    value={channelData.sector}
                    dataKey="sector"
                    editable={editable}
                  />
                </SelectListWrapper>
                <SelectListWrapper>
                  <ChannelDataSelectList
                    label="FUNKTION"
                    options={linkedInFunctions}
                    value={channelData.function}
                    dataKey="function"
                    editable={editable}
                  />
                </SelectListWrapper>
              </SelectListsWrapper>
              <RequirementsDetails>Jobanzeigen-Details</RequirementsDetails>
            </Requirements>
          )}
          <HTMLEditorWrapper>
            <HTMLEditor
              html={postData.jobPostingMarkup}
              updatePost={updatePost}
              editable={editable}
            />
          </HTMLEditorWrapper>
        </BodyContent>
        <Underline />
      </BodyWrapper>
    </PostEditorLinkedInWrapper>
  );
};

export default PrintPostEditorLinkedIn;
